export default "__VITE_ASSET__C95CG66J__"